import React, { useRef, useState } from "react";
import {
  MenuItem,
  TextField,
  Select,
  OutlinedInput,
  InputLabel,
  FormControl,
} from "@mui/material";
import "./AppInputField.style.css";
import MUIErrorText from "../../MUIErrorText/MUIErrorText";
import { AppTheme } from "../../../theme/App.theme";

const defaultInputProps = { sx: { borderRadius: 1 } };

const AppInputField = ({
  OnChange,
  Type,
  Label,
  PlaceHolder,
  Size,
  Value,
  Id,
  Error,
  OnBlur,
  OnInput,
  IsMultiLine,
  IsMultiSelect,
  Name,
  HelperText,
  MaxRows,
  Disabled,
  IsSelect,
  InputProps,
  ClassName,
  TextFieldStyle,
  TextFieldSX,
  StyleForSelect,
  SXForSelect,
  SelectOptions = [],
  SortOptions = true,
  StartAdornmentForSelect,
  IsCapitalizeRequired = false,
}) => {
  const selectRef = useRef(null); // Reference to the Select component
  const [menuWidth, setMenuWidth] = useState(null);

  const handleOpen = () => {
    if (selectRef.current) {
      // Get the width of the Select component
      setMenuWidth(selectRef.current.offsetWidth);
    }
  };

  // Sort options if `sort` is true
  const sortedOptions = SortOptions
    ? [...SelectOptions].sort((a, b) => {
        if (a.label === "All") return -1;
        if (b.label === "All") return 1;
        return a.label.localeCompare(b.label);
      })
    : SelectOptions;

  // Handle onChange with capitalization logic
  const handleTextFieldChange = (event) => {
    const { value, name, selectionStart, selectionEnd } = event.target;

    // Check if capitalization is required
    const updatedValue = IsCapitalizeRequired
      ? value.charAt(0).toUpperCase() + value.slice(1)
      : value;

    // Update the event target value with the updatedValue
    const updatedEvent = {
      ...event,
      target: {
        ...event.target,
        name: name,
        value: updatedValue,
      },
    };

    // Adjust cursor position if capitalization changed the value
    // const cursorAdjustment = updatedValue.length - value.length;

    // Call the provided onChange handler with the updated event
    if (OnChange) {
      OnChange(updatedEvent);
      // Restore cursor position
      // setTimeout(() => {
      //   const inputElement = event.target;
      //   inputElement.setSelectionRange(
      //     selectionStart + cursorAdjustment,
      //     selectionEnd + cursorAdjustment
      //   );
      // }, 0);
    }
  };

  return (
    <React.Fragment>
      {!IsSelect ? (
        <TextField
          name={Name}
          style={{
            ...TextFieldStyle,
            backgroundColor: Disabled && AppTheme.MUTED_LIGHT,
          }}
          sx={{ ...TextFieldSX }}
          className={ClassName}
          InputProps={InputProps ? InputProps : defaultInputProps}
          autoComplete="off"
          type={Type}
          label={Label}
          placeholder={PlaceHolder || Label}
          id={Id ? Id : "my-id"}
          size={Size ? Size : "small"}
          value={Value ? Value : ""}
          fullWidth
          disabled={Disabled ? Disabled : false}
          onChange={handleTextFieldChange}
          onInput={OnInput}
          onBlur={OnBlur}
          error={Error}
          multiline={IsMultiLine}
          maxRows={MaxRows ? MaxRows : 4}
          helperText={HelperText}
          slotProps={{
            inputLabel: {
              style: {
                fontSize: "14px",
              }
            }
          }}
        />
      ) : (
        <FormControl fullWidth size={Size}>
          <InputLabel
            id={Label}
            style={{ fontSize: "14px", color: Error && "#f15750" }}
            size={Size || "small"}
          >
            {Label}
          </InputLabel>
          <Select
            labelId={Id ? Id : "my-id"}
            ref={selectRef}
            id={Id}
            input={<OutlinedInput label={Label} />}
            startAdornment={StartAdornmentForSelect || null}
            className={ClassName}
            style={{
              ...StyleForSelect,
              // backgroundColor: Disabled && AppTheme.MUTED_LIGHT,
            }}
            onOpen={handleOpen}
            sx={{
              ...SXForSelect,
              color: Value === "" && !Label && "#636363",
              backgroundColor: Disabled && AppTheme.MUTED_LIGHT,
              // "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
              //   borderColor: `${AppTheme.MUTED_LIGHT}`, // Change this to the color you want
              // },
            }}
            name={Name}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 200,
                  maxWidth: menuWidth, // You can adjust this value
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                },
              },
            }}
            type={Type}
            placeholder={PlaceHolder}
            size={Size ? Size : "small"}
            value={Value ? Value : ""}
            fullWidth
            disabled={Disabled ? Disabled : false}
            onChange={OnChange}
            onBlur={OnBlur}
            error={Error}
            multiline={IsMultiLine}
            multiple={IsMultiSelect}
            maxRows={MaxRows ? MaxRows : 4}
            displayEmpty={PlaceHolder ? true : false}
          >
            {PlaceHolder && (
              <MenuItem value="" disabled style={{ textWrap: "wrap" }}>
                {PlaceHolder || "Select"}
              </MenuItem>
            )}
            {sortedOptions.map((type, index) => (
              <MenuItem
                key={index}
                style={{ textWrap: "wrap" }}
                value={type.value}
                id={type.id}
                disabled={type.isDisabled || false}
                className="custom-textfield-select"
              >
                {type.label}
              </MenuItem>
            ))}
          </Select>
          {Error && (
            <div className="ms-3">
              <MUIErrorText ErrorMessage={HelperText} />
            </div>
          )}
        </FormControl>
      )}
    </React.Fragment>
  );
};

export default AppInputField;
